module.exports = __webpack_public_path__ + "img/video_icon04.466b56d2.png";